import { inject, Injectable, Provider } from '@angular/core';
import { Observable } from 'rxjs';
import { ProductIdentifierDto, TechGroupFeatureListGetQuery, TechGroupFeatureListGetQueryResult, TechGroupFeatureRegisterListGetQuery, TechGroupFeatureRegisterListGetQueryResult, TechGroupGetQuery } from '../../INTEGRA_Shop_Client';
import { ITechGroupApiService, ITechGroupApiServiceToken } from '../../api/tech-group/tech-group-api-service.interface';
import { ITechGroupService, ITechGroupServiceToken } from './tech-group-service.interface';

@Injectable({
  providedIn: 'root'
})
export class TechGroupService implements ITechGroupService {
  private readonly techGroupApiService: ITechGroupApiService;

  public constructor() {
    this.techGroupApiService = inject(ITechGroupApiServiceToken);
  }

  public async techGroupGetAsync(techGroupNumber: string) {
    let query = new TechGroupGetQuery({
      techGroupNumber: techGroupNumber
    });

    return this.techGroupApiService.swagTechGroupGetAsync(query);
  }

  public techGroupFeatureListGet(techGroupNumber?: string, productList?: ProductIdentifierDto[], filterNonTrueBoolAttributes?: boolean): Observable<TechGroupFeatureListGetQueryResult> {
    let query = new TechGroupFeatureListGetQuery({
      techGroupNumber: techGroupNumber,
      productList: productList,
      filterNonTrueBoolAttributes: filterNonTrueBoolAttributes
    });

    return this.techGroupApiService.swagTechGroupFeatureListGet(query);
  }
  public techGroupFeatureRegisterListGet(techGroupNumber?: string, productList?: ProductIdentifierDto[], filterNonTrueBoolAttributes?: boolean): Observable<TechGroupFeatureRegisterListGetQueryResult> {
    let query = new TechGroupFeatureRegisterListGetQuery({
      techGroupNumber: techGroupNumber,
      productList: productList,
      filterNonTrueBoolAttributes: filterNonTrueBoolAttributes
    });

    return this.techGroupApiService.swagTechGroupFeatureRegisterListGet(query);
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const TechGroupServiceProvider: Provider[] = [
  { provide: ITechGroupServiceToken, useExisting: TechGroupService }
];
